import { render, staticRenderFns } from "./experiencia.vue?vue&type=template&id=1ddc3a0c&"
import script from "./experiencia.vue?vue&type=script&lang=js&"
export * from "./experiencia.vue?vue&type=script&lang=js&"
import style0 from "./experiencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports